import React, { useState, useEffect ,useRef,useLayoutEffect} from "react";

import { Row, Col, Input, Form, Upload, message, Button ,Spin } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { UploadOutlined } from "@ant-design/icons";
import moment from "jalali-moment";
import { API_URL } from "../../../../constants";
import useAxios from "@use-hooks/axios";
import isEmail from "validator/lib/isEmail";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/ContactUs/WorkWithUs/WorkWithUs.css";

const workWithUsCard = {
  opacity: "90%",
  backgroundColor: "#fff",
  borderRadius: "20px",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  padding: "25px",
};
const contactInput = {
  textAlign: "right",
  direction: "rtl",
  paddingRight: "30px",
  fontFamily: "IranSans",
  fontSize: ".9em",
  borderRadius: "15px",
};
const contactInputTablet = {
  textAlign: "right",
  direction: "rtl",
  paddingRight: "30px",
  fontFamily: "IranSans",
  fontSize: ".85em",
  borderRadius: "15px",
};
const contactInputMobile = {
  textAlign: "center",
  direction: "rtl",
  fontFamily: "IranSans",
  fontSize: ".8em",
  borderRadius: "15px",
};

const WorkWithUsMain = (props) => {
  const [form] = Form.useForm();
  const [postvalues, setPostValues] = useState();
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);

  const postCollabrate = useAxios({
    url: `${API_URL}/Collabrate_Service/`,
    method: "POST",
    options: {
      data: postvalues,
    },
    trigger: postvalues,

    forceDispatchEffect: () => !!postvalues,
    customHandler: (err, res) => {
      if (res) {
        console.log("rest", res);
        message.success("ذخیره اطلاعات");
        setLoading(false);

        form.resetFields();
      }
    },
  });

  const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    console.log("here");

    setLoading(true);
  }, [postvalues]);

  useEffect(() => {
    setFileList([]);
  }, [postvalues]);

  const handleupload = (file, List) => {
    setFileList(List);
  };

  const onFinish = (values) => {
    console.log(values);
    const formData = new FormData();
    if (isEmail(values.email)) {
      if (values.phone.length == 11) {
        if (fileList.length > 0) {
          formData.append("first_and_last_name", values.name);
          formData.append("email", values.email);
          formData.append("code", values.code);
          formData.append("phone_number", values.phone);
          formData.append("file", fileList[0], fileList[0].name);
          formData.append("birth_date", values.birth_date);
          setPostValues(formData);
        } else {
          message.error("افزودن فایل");
        }
      } else {
        message.error("شماره همراه معتبر نیست");
      }
    } else {
      message.error("پست الکترونیک را وارد نمایید");
    }
    // if (!isGetDate) {
    //   console.log(moment().locale("en").format("YYYY-MM-DD"));
    //   formData.append("date", moment().locale("en").format("YYYY-MM-DD"));
    // } else {
    //   console.log(date);
    //   formData.append("date", date);
    // }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  //   const validateEmail = (rule, email) => {
  //     console.log("email", email);
  //     if (!isEmail(email)) return Promise.resolve();
  //     return Promise.reject("input email");
  //   };

  const isNumeric = (rule, value) => {
    if (!isNaN(value)) return Promise.resolve();

    return Promise.reject("لطفا عدد وارد نمایید");
  };
  return props.size === "laptopdesktop" ? (
    <div className="workWithUsBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
            <strong>همکاری با ما</strong>
          </p>
        </Center>
      </div>
      <Spin spinning={loading}>
        <Form
          onFinish={onFinish}
          initialValues={{
            created_at: moment().locale("fa").format("YYYY-MM-DD"),
          }}
          form={form}
          onFinishFailed={onFinishFailed}
        >
          <Row style={{ marginTop: "150px" }}>
            <Col span={5}></Col>
            <Col span={14}>
              <div style={workWithUsCard}>
                <Row>
                  <Col span={8}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="phone"
                        dir="rtl"
                        rules={[
                          {
                            validator: isNumeric,
                          },
                          {
                            required: true,
                            message: "شماره موبایل را وارد نمایید",
                          },
                        ]}
                      >
                        <Input
                          style={contactInput}
                          placeholder="شماره موبایل"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="code"
                        rules={[
                          {
                            validator: isNumeric,
                          },
                          {
                            required: true,
                            message: "کد ملی را وارد نمایید",
                          },
                        ]}
                      >
                        <Input style={contactInput} placeholder="کدملی" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="name"
                        rules={[
                          {
                            required: true,
                            message: "نام و نام خانوادگی را وارد نمایید",
                          },
                        ]}
                      >
                        <Input
                          style={contactInput}
                          placeholder="نام و نام خانوادگی"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Margin top={3}></Margin>
                <Row>
                  <Col span={8}>
                    <div style={{ margin: "10px", width: "100%" }}>
                      <Upload
                        fileList={fileList}
                        style={{ width: "100%" }}
                        beforeUpload={handleupload}
                      >
                        <Button
                          style={{ borderRadius: "20px", width: "225px" }}
                        >
                          <p style={contactInput}>
                            آپلود فایل رزومه
                            <UploadOutlined />
                          </p>
                        </Button>
                      </Upload>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="birth_date"
                        rules={[
                          //     {
                          //       validator: validateEmail,
                          //     },
                          {
                            required: true,
                            message: "تاریخ تولد را وارد نمایید",
                          },
                        ]}
                      >
                        <Input
                          style={contactInput}
                          placeholder="تاریخ تولد ۱۳۹۹/۱۲/۲۴"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="email"
                        rules={[
                          //     {
                          //       validator: validateEmail,
                          //     },
                          {
                            required: true,
                            message: "پست الکترونیک را وارد نمایید",
                          },
                        ]}
                      >
                        <Input
                          style={contactInput}
                          placeholder="پست الکترونیک"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>

                <Margin top={3}></Margin>
                <Row>
                  <Col
                    span={18}
                    style={{ direction: "ltr", textAlign: "left" }}
                  >
                    <div style={{ margin: "10px" }}>
                      {/* <a
                      href="#"
                      class="introBtn introBtn-white introBtn-animated"
                      style={{
                        fontSize: ".8em",
                        fontFamily: "IRANSans",
                        paddingRight: "30px",
                        paddingLeft: "30px",
                      }}
                    >
                      ارسال
                    </a> */}
                      <Form.Item>
                        <Button
                          htmlType="submit"
                          class="introBtn introBtn-white introBtn-animated"
                          style={{
                            fontSize: ".85em",
                            fontFamily: "IRANSans",
                            paddingRight: "20px",
                            paddingLeft: "20px",
                            paddingTop: "1.5px",
                            paddingBottom: "1.5px",
                            backgroundColor: "#186491",
                            color: "#fff",
                            borderRadius: "100px",
                          }}
                        >
                          ارسال
                        </Button>
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={6}></Col>
                </Row>
              </div>
              <Margin bottom={5}></Margin>
            </Col>
            <Col span={5}></Col>
          </Row>
        </Form>
      </Spin>
    </div>
  ) : props.size === "tablet" ? (
    <div className="workWithUsBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft">
            <strong>همکاری با ما</strong>
          </p>
        </Center>
      </div>
      <Spin spinning={loading}>
        <Form
          onFinish={onFinish}
          initialValues={{
            created_at: moment().locale("fa").format("YYYY-MM-DD"),
          }}
          form={form}
          onFinishFailed={onFinishFailed}
        >
          <Row style={{ marginTop: "75px" }}>
            <Col span={1}></Col>
            <Col span={22}>
              <div style={workWithUsCard}>
                <Row>
                  <Col span={8}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="phone"
                        dir="rtl"
                        rules={[
                          {
                            validator: isNumeric,
                          },
                          {
                            required: true,
                            message: "شماره موبایل را وارد نمایید",
                          },
                        ]}
                      >
                        <Input
                          style={contactInputTablet}
                          placeholder="شماره موبایل"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="code"
                        rules={[
                          {
                            validator: isNumeric,
                          },
                          {
                            required: true,
                            message: "کد ملی را وارد نمایید",
                          },
                        ]}
                      >
                        <Input style={contactInputTablet} placeholder="کدملی" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="name"
                        rules={[
                          {
                            required: true,
                            message: "نام و نام خانوادگی را وارد نمایید",
                          },
                        ]}
                      >
                        <Input
                          style={contactInputTablet}
                          placeholder="نام و نام خانوادگی"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Margin top={3}></Margin>
                <Row>
                  <Col span={8}>
                    <div style={{ margin: "10px", width: "100%" }}>
                      <Upload
                        fileList={fileList}
                        style={{ width: "100%" }}
                        beforeUpload={handleupload}
                      >
                        <Button
                          style={{ borderRadius: "20px", width: "150px" }}
                        >
                          <p style={contactInput}>
                            آپلود فایل رزومه
                            <UploadOutlined />
                          </p>
                        </Button>
                      </Upload>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="birth_date"
                        rules={[
                          //     {
                          //       validator: validateEmail,
                          //     },
                          {
                            required: true,
                            message: "تاریخ تولد را وارد نمایید!",
                          },
                        ]}
                      >
                        <Input
                          style={contactInputTablet}
                          placeholder="تاریخ تولد ۱۳۹۹/۱۲/۲۴"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="email"
                        rules={[
                          //     {
                          //       validator: validateEmail,
                          //     },
                          {
                            required: true,
                            message: "پست الکترونیک را وارد نمایید",
                          },
                        ]}
                      >
                        <Input
                          style={contactInputTablet}
                          placeholder="پست الکترونیک"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>

                <Margin top={2}></Margin>
                <Row>
                  <Col
                    span={18}
                    style={{ direction: "ltr", textAlign: "left" }}
                  >
                    <div style={{ margin: "10px" }}>
                      {/* <a
                      href="#"
                      class="introBtn introBtn-white introBtn-animated"
                      style={{
                        fontSize: ".75em",
                        fontFamily: "IRANSans",
                        paddingRight: "30px",
                        paddingLeft: "30px",
                      }}
                    >
                      ارسال
                    </a> */}
                      <Form.Item>
                        <Button
                          htmlType="submit"
                          class="introBtn introBtn-white introBtn-animated"
                          style={{
                            fontSize: ".8em",
                            fontFamily: "IRANSans",
                            paddingRight: "20px",
                            paddingLeft: "20px",
                            paddingTop: "1.5px",
                            paddingBottom: "1.5px",
                            backgroundColor: "#186491",
                            color: "#fff",
                            borderRadius: "100px",
                          }}
                        >
                          ارسال
                        </Button>
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={6}></Col>
                </Row>
              </div>
              <Margin bottom={5}></Margin>
            </Col>
            <Col span={1}></Col>
          </Row>
        </Form>
      </Spin>
    </div>
  ) : (
    <div className="workWithUsBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile">
            <strong>همکاری با ما</strong>
          </p>
        </Center>
      </div>
      <Spin spinning={loading}>
        <Form
          onFinish={onFinish}
          initialValues={{
            created_at: moment().locale("fa").format("YYYY-MM-DD"),
          }}
          form={form}
          onFinishFailed={onFinishFailed}
        >
          <Row style={{ marginTop: "50px" }}>
            <Col span={1}></Col>
            <Col span={22}>
              <div style={workWithUsCard}>
                <Row>
                  <Col span={24}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="name"
                        rules={[
                          {
                            required: true,
                            message: "نام و نام خانوادگی را وارد نمایید",
                          },
                        ]}
                      >
                        <Input
                          style={contactInputMobile}
                          placeholder="نام و نام خانوادگی"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="code"
                        rules={[
                          {
                            validator: isNumeric,
                          },
                          {
                            required: true,
                            message: "کد ملی را وارد نمایید",
                          },
                        ]}
                      >
                        <Input style={contactInputMobile} placeholder="کدملی" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="phone"
                        dir="rtl"
                        rules={[
                          {
                            validator: isNumeric,
                          },
                          {
                            required: true,
                            message: "شماره موبایل را وارد نمایید",
                          },
                        ]}
                      >
                        <Input
                          style={contactInputMobile}
                          placeholder="شماره موبایل"
                        />
                      </Form.Item>
                    </div>
                  </Col>

                  <Col span={24}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="birth_date"
                        rules={[
                          //     {
                          //       validator: validateEmail,
                          //     },
                          {
                            required: true,
                            message: "تاریخ تولد را وارد نمایید!",
                          },
                        ]}
                      >
                        <Input
                          style={contactInputMobile}
                          placeholder="تاریخ تولد ۱۳۹۹/۱۲/۲۴"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div style={{ margin: "10px" }}>
                      <Form.Item
                        name="email"
                        rules={[
                          //     {
                          //       validator: validateEmail,
                          //     },
                          {
                            required: true,
                            message: "پست الکترونیک را وارد نمایید",
                          },
                        ]}
                      >
                        <Input
                          style={contactInputMobile}
                          placeholder="پست الکترونیک"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div style={{ margin: "10px" }}>
                      <Upload
                        fileList={fileList}
                        style={{ width: "100%" }}
                        beforeUpload={handleupload}
                      >
                        <Button
                          style={{ borderRadius: "20px", width: "225px" }}
                        >
                          <p style={contactInput}>
                            آپلود فایل رزومه
                            <UploadOutlined />
                          </p>
                        </Button>
                      </Upload>
                    </div>
                  </Col>
                </Row>
                <Margin top={3}></Margin>
                <Row>
                  <Col
                    span={18}
                    style={{ direction: "ltr", textAlign: "left" }}
                  >
                    <div style={{ margin: "10px" }}>
                      <Form.Item>
                        <Button
                          htmlType="submit"
                          class="introBtn introBtn-white introBtn-animated"
                          style={{
                            fontSize: ".75em",
                            fontFamily: "IRANSans",
                            paddingRight: "20px",
                            paddingLeft: "20px",
                            paddingTop: "1.5px",
                            paddingBottom: "1.5px",
                            backgroundColor: "#186491",
                            color: "#fff",
                            borderRadius: "100px",
                          }}
                        >
                          ارسال
                        </Button>
                      </Form.Item>
                      {/* <a
                      href="#"
                      class="introBtn introBtn-white introBtn-animated"
                      style={{
                        fontSize: ".7em",
                        fontFamily: "IRANSans",
                        paddingRight: "30px",
                        paddingLeft: "30px",
                      }}
                    >
                      ارسال
                    </a> */}
                    </div>
                  </Col>
                  <Col span={6}></Col>
                </Row>
              </div>
              <Margin bottom={5}></Margin>
            </Col>
            <Col span={1}></Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
};

export default WorkWithUsMain;
